/* eslint-disable import/prefer-default-export */
import { useEffect, useState } from "react";
import i18next from "i18next";

const useDetectLanguage = (location) => {
  const [languageCode, setLanguageCode] = useState("en");

  useEffect(() => {
    if (!location) {
      return;
    }

    const pathParts = location.pathname.split("/");
    const langCode = pathParts[1];

    if (i18next.languages.includes(langCode)) {
      i18next.changeLanguage(langCode);
      setLanguageCode(langCode);
    }
  }, [location]);

  return {
    languageCode,
  };
};

export { useDetectLanguage };
